import { render, staticRenderFns } from "./DescribePanel.vue?vue&type=template&id=b5c100ac&scoped=true"
import script from "./DescribePanel.vue?vue&type=script&lang=ts"
export * from "./DescribePanel.vue?vue&type=script&lang=ts"
import style0 from "./DescribePanel.vue?vue&type=style&index=0&id=b5c100ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c100ac",
  null
  
)

export default component.exports